import axios from 'axios';
import React, { useEffect, useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';

const CouponsPage = () => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeSort, setActiveSort] = useState("All");



  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      const res = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_new_coupon"
      );

      if (res.data?.status === "true") {
        setCoupons(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching coupons", error);
    } finally {
      setLoading(false);
    }
  };


  const copyToClipboard = (code) => {
    navigator.clipboard.writeText(code);
  };

  return (
    <div className="container-fluid" style={{ backgroundColor: '#f5f5f5', minHeight: "100vh", marginTop: "115px" }}>
      <div className="row">
        {/* Main Content */}
        <div className="col-md-12 col-lg-12 px-4">
          <div className="bg-white rounded p-3 p-md-4">
            {/* Sort Options */}
            <div className="mb-4">
              <span className="me-3 fw-bold">Sort by:</span>
              {['Trending', 'Discount', 'Expiring Soon', 'All'].map((sort) => (
                <button
                  key={sort}
                  className={`btn me-2 mb-2 ${activeSort === sort ? 'btn-outline-danger' : 'btn-outline-secondary'}`}
                  style={{
                    borderRadius: '20px',
                    ...(activeSort === sort && { backgroundColor: '#fff', color: '#ff3f6c', borderColor: '#ff3f6c' })
                  }}
                  onClick={() => setActiveSort(sort)}
                >
                  {sort}
                </button>
              ))}
            </div>

            {/* Coupons Grid */}
            <div className="row">
              {coupons.map((coupon) => (
                <div key={coupon.coupon_id} className="col-12 col-md-6">
                  <div className="card h-100" style={{ border: "1px solid #e0e0e0" }}>
                    <div className="card-body">
                      <div className="row">
                        {/* Image (static or based on discount type) */}
                        <div className="col-4 col-md-3">
                          <img
                            src="https://images.unsplash.com/photo-1549298240-0d8e60513026?w=300"
                            alt="coupon"
                            className="img-fluid rounded"
                            style={{ height: "100px", objectFit: "cover" }}
                          />
                        </div>

                        <div className="col-8 col-md-9">
                          <h6 className="fw-bold mb-2">
                            {coupon.discount_type === "percentage"
                              ? `Flat ${coupon.discount_value}% OFF`
                              : `Flat ₹${coupon.discount_value} OFF`}
                          </h6>

                          <p className="text-muted small mb-2">
                            Min order ₹{coupon.minimum_order_value}
                          </p>

                          <div className="d-flex align-items-center mb-2">
                            <span className="small me-2">
                              Code: <strong>{coupon.coupon_code}</strong>
                            </span>
                            <button
                              className="btn btn-link p-0"
                              onClick={() =>
                                navigator.clipboard.writeText(coupon.coupon_code)
                              }
                            >
                              <i className="bi bi-clipboard"></i>
                            </button>
                          </div>

                          <p className="small text-muted mb-2">
                            Expiry: {new Date(coupon.expiry_date).toDateString()}
                          </p>

                          <span
                            className={`badge ${coupon.status === "active"
                                ? "bg-success"
                                : "bg-secondary"
                              }`}
                          >
                            {coupon.status}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="d-md-none fixed-bottom bg-white border-top">
        <div className="row g-0 text-center">
          <div className="col">
            <button className="btn btn-link text-dark py-3 w-100">
              <i className="bi bi-house d-block"></i>
              <small>Home</small>
            </button>
          </div>
          <div className="col">
            <button className="btn btn-link text-dark py-3 w-100">
              <i className="bi bi-search d-block"></i>
              <small>Search</small>
            </button>
          </div>
          <div className="col">
            <button className="btn btn-link text-dark py-3 w-100">
              <i className="bi bi-heart d-block"></i>
              <small>Wishlist</small>
            </button>
          </div>
          <div className="col">
            <button className="btn btn-link text-danger py-3 w-100">
              <i className="bi bi-person d-block"></i>
              <small>Account</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponsPage;